// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"967":"c9fc5ff9","971":"c9fc5ff9"}[chunkId] + ".chunk.css";
};